import axios from "axios";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Constants } from "../../Constants";

const Authorize = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const authorize = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const token = localStorage.getItem("authToken");
      const httpOptions = {
        headers: {
          Authorization: token,
        },
      };
      await axios.post(
        `${Constants.BASE_URL}authorize/link-account`,
        { code },
        httpOptions
      );
      history.push("/config");
    };
    authorize();
  }, []);

  return <p>Iniciando sesión con MercadoLibre...</p>;
};

export default Authorize;
